import { businessToday } from "utils/businessDate";

export { businessToday };

/**
 * A new date may be today or later. An unchanged date is left alone, so an offer or terms version
 * whose date has since passed can still be edited. Mirrors the server rule.
 */
export const pastDateProblem = (value, original, what, today = businessToday()) => {
  if (!value || value === original) return null;
  return value < today ? `${what} cannot be in the past. Pick today or a later date.` : null;
};

/** The `min` for a date input: none while it still holds its saved (possibly past) value. */
export const minDateFor = (value, original, today = businessToday()) =>
  value && value === original ? undefined : today;
